import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { queryParser } from '../utils';
import { selectFlow, setShowCookieBanner } from '../store/app';

export const useCookieBanner = (path: string) => {
  const dispatch = useDispatch();
  const flow = useSelector(selectFlow);
  const { skip_cookies } = queryParser(window?.location.search);
  const isFlowPage = flow?.indexOf(path.replace('/', '')) >= 0;

  useLayoutEffect(() => {
    dispatch(setShowCookieBanner(skip_cookies !== 'true' && !isFlowPage));
  }, [dispatch, skip_cookies, isFlowPage]);
};
